import { environment } from 'src/environment';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { SettingsService, BaseService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import { UserDevicesService } from 'src/app/core/services/user-devices.service';
import { logoutDevices } from 'src/app/shared/constants';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import * as $ from 'jquery';
import * as uikit from 'uikit'
import { ApplicationService } from 'src/app/core/services/application.service';
import { HttpParams } from '@angular/common/http';
import { MyAccountService } from 'src/app/core/services/my-account.service';
import { NgFor, NgIf } from '@angular/common';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { DatetimeFormatPipe } from '../../pipes/datetime-format.pipe';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';

@Component({
  selector: 'app-manage-devices',
  templateUrl: './manage-devices.component.html',
  styleUrls: ['./manage-devices.component.scss', '../modal-screens.scss'],
  standalone: true,
  imports: [NgIf, NgFor, ChangePasswordComponent, ReactiveFormsModule, FormsModule, DatetimeFormatPipe]
})
export class ManageDevicesComponent implements OnInit {
  inputForm: FormGroup
  devices;
  response;
  deviceData;
  removedData;
  length;
  url;
  homeImage: any;
  showEdit = false;
  editDevice = -1;
  currentDevice;
  @Input() errorMsg;
  error = false;
  userId;
  userSettings;
  currentUrl;
  innerWidth;
  isInputEmpty = true;
  disableSignoutButton = false;
  skinName = environment.skinName;
  hideDevices = true;
  constructor(public settingsService: SettingsService, private userdevicesService: UserDevicesService,
    private uikitService: UikitService, private router: Router, private baseService: BaseService,
    private loggerService: LoggerService, private storageService: StorageService, private analyticsService: InhouseAnalyticsService,
    public configService: ConfigurationService, private formBuilder: FormBuilder, public applicationService: ApplicationService,
    public accountService: MyAccountService) {
    this.userId = this.storageService.getLocalStore('u_id');
    this.currentDevice = this.storageService.getLocalStore('d_id');
    this.inputForm = this.formBuilder.group({
      newName: ['', Validators.required]
    })
    this.innerWidth = window.innerWidth;
  }

  ngOnInit(): void {
    if (this.userId) {
      if (!this.applicationService.userLoginBy) {
        this.accountService.getAccountDetails().subscribe();
      }
    }
    if (this.errorMsg) this.error = true;
    this.currentUrl = this.router.url;
    if(!this.userId){
      this.userdevicesService.devicesList.subscribe(data => {
        this.devices = data;
        this.hideDevices = false;
      })
    }
    this.response = {};
    if (this.userId) {
      this.userdevicesService.getUserDevice(this.response).subscribe({
        next: data => {
          this.deviceData = data;
        }, complete: () => {
          if (this.deviceData.status_code === 200) {
            this.devices = this.deviceData.data.devices;
            this.hideDevices = false;
            this.userdevicesService.devicesList.next(this.deviceData.data.devices);
            this.length = this.devices.length;
          } else {
            this.uikitService.staticErrorMessage(this.deviceData.error.message);
          }
          if (this.deviceData.error && this.deviceData.error.code !== 1002) {
            this.uikitService.staticErrorMessage(this.deviceData.error.message);
          }
          return false;
        }
      });
    }
    const inputField = this.inputForm.get('newName');
    inputField.valueChanges.subscribe(() => {
      this.checkInputValue()
    })
    this.applicationService.closeDeviceEdit.subscribe((data) => {
      if (data) this.cancelEdit();
    })
  }

  checkInputValue() {
    const inputField = this.inputForm.get('newName');
    this.isInputEmpty = !inputField.value || inputField.value.trim().length === 0;
  }

  removeAllDevice(id, currentDevice) {
    if (!this.userId) this.storageService.setLocalStore('a_t', this.loggerService.newAccessToken);
    if (id !== '') {
      this.url = logoutDevices + '/' + id;
    } else {
      this.url = logoutDevices;
    }
    this.userdevicesService.removeUserDevice(this.url).subscribe({
      next: data => {
        this.removedData = data;
        const eventObj = {
          event_type: 'Event',
          event_name: 'Remove All Devices',
          event_status: 'Success',
        };
        this.analyticsService.trackUserActions(eventObj);
      }, error: err => {
        this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
        const eventObj = {
          event_type: 'Event',
          event_name: 'Remove All Devices',
          event_status: 'Failure',
        };
        this.analyticsService.trackUserActions(eventObj);
      }, complete: () => {
        if (this.removedData.status_code === 200) {
          this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
          if (id === '' || currentDevice === 1) {
            this.loggerService.updatedMemoryStorage(undefined);
            this.storageService.removeLocalStore('a_t');
            this.storageService.removeLocalStore('r_t');
            this.storageService.setLocalStore('logged_in', '0');
            this.storageService.removeLocalStore('u_id');
            sessionStorage.removeItem('profileId');
            this.storageService.removeLocalStore('sessionStorage');
            this.storageService.removeLocalStore('event_user_status');
            document.cookie = 'u_id=; domain=' + environment.cookieDomain + '; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            this.baseService.guestSource.next(true);
            let utm_url = this.settingsService.getUTMurl(environment.paywallURL);
            window.location.href = utm_url;
            // if (this.baseService.loginMode === 1) {
            //   this.router.navigateByUrl('index');
            // } else {
            //   this.router.navigateByUrl('home');
            // }
          } else {
            window.location.reload();
          }
        } else {
          this.uikitService.staticErrorMessage(this.removedData.error.message);
        }
        if (this.removedData.error && this.removedData.error.code !== 1002) {
          this.uikitService.staticErrorMessage(this.removedData.error.message);
        }
      }
    });
  }

  openEdit(i) {
    this.showEdit = true;
    this.editDevice = i;
    this.inputForm.get('newName').reset();
    this.isInputEmpty = true;
  }
  cancelEdit() {
    this.showEdit = false;
    this.editDevice = -1;
    this.inputForm.get('newName').reset();
    this.isInputEmpty = true;
    this.applicationService.closeDeviceEdit.next(false)
  }
  openUikitDialog(modelId) {
    if (modelId == '#change-password' && !this.currentUrl.includes('/account/m/manage-devices')) {
      const modal = uikit.modal('#manage-devices');
      modal.hide();
    }
    if (this.currentUrl.includes('/account/m/manage-devices') && modelId == '#change-password') {
      let model = '#change-password-mobile';
      $(model).addClass('uk-open').show();
    }
    $(modelId).addClass('uk-open').show();
  }
  opensignoutDialog(i) {
    const modelId = `#${i}`;
    $(modelId).addClass('uk-open').show();
  }
  closeAllSignout() {
    const modal = uikit.modal('#all-signout');
    modal.hide();
  }
  closeSignout(i) {
    const modelId = `#${i}`;
    $(modelId).removeClass('uk-open');
  }

  editName(device) {
    if (this.inputForm.valid) {
      if (!this.userId) this.storageService.setLocalStore('a_t', this.loggerService.newAccessToken);
      let data = {
        newName: this.inputForm.value.newName,
        deviceId: device.device_id
      }
      this.userdevicesService.editUserDeviceName(data).subscribe((data) => {
        if (data) {
          if (!this.userId) this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
          this.devices.find((data) => {
            if (data.device_id == device.device_id) {
              data.device_title = this.inputForm.value.newName
            }
          });
          this.showEdit = false;
          this.editDevice = -1;
          const eventObj = {
            event_type: 'Event',
            event_name: 'Edit Device Name - Manage Device',
            event_status: 'Success',
          };
          this.analyticsService.trackUserActions(eventObj);
        }
      }, (error) => {
        if (!this.userId) this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
        const eventObj = {
          event_type: 'Event',
          event_name: 'Edit Device Name - Manage Device',
          event_status: 'Failure',
        };
        this.analyticsService.trackUserActions(eventObj);
      })
    }
  }

  removeDevice(dev, i) {
    this.disableSignoutButton = true;
    if (!this.userId) this.storageService.setLocalStore('a_t', this.loggerService.newAccessToken);
    const dId: string = this.storageService.getLocalStore('d_id');
    this.userdevicesService.logoutDevice(dev).subscribe((data) => {
      this.disableSignoutButton = false;
      if (data) {
        this.closeSignout(i);
        const eventObj = {
          event_type: 'Event',
          event_name: 'Signout Device',
          event_status: 'Success',
        };
        this.analyticsService.trackUserActions(eventObj);

        if (!this.userId) this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
        this.devices = this.devices.filter((data) => {
          if (data.device_id != dev.device_id) {
            return data;
          }
        });
        if (!this.userId) {
          let deviceId = this.storageService.getLocalStore('d_id');
          let userId = this.loggerService.newUserId;
          let paramurl = '/' + deviceId + '/' + userId;
          this.storageService.setLocalStore('a_t', this.loggerService.newAccessToken);
          let params = new HttpParams()
            .set('logged_in', '1')
            .set('locale', this.storageService.getLocalStore('locale'));
          const user_settings = this.applicationService.getUserSettings(params, paramurl);
          user_settings.then((data) => {
            this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
            this.userSettings = data;
            if (this.userSettings.device_limit_exceed == 0) this.loggerService.loginFn(this.loggerService.loginPostData);
          }).catch((error) => {
            this.disableSignoutButton = false;
            this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
            console.error(error);
          })
        }
      }
    }, (error) => {
      this.disableSignoutButton = false;
      this.storageService.setLocalStore('a_t', this.loggerService.oldAccessToken);
      console.log(error);
      const eventObj = {
        event_type: 'Event',
        event_name: 'Signout Device',
        event_status: 'Success',
        event_description: error
      };
      this.analyticsService.trackUserActions(eventObj);
    })
  }

}
